// @ts-expect-error three-dxf-loader does not have TS
import occtimportjs from 'occt-import-js'
import * as THREE from 'three'

class STEPLoader extends THREE.Loader {
  load(
    url: string,
    onLoad: (group: THREE.Object3D) => void,
    onProgress?: (event: ProgressEvent) => void,
    onError?: (err: unknown) => void,
  ) {
    const loader = new THREE.FileLoader(this.manager)
    loader.setPath(this.path)
    loader.setRequestHeader(this.requestHeader)
    loader.setWithCredentials(this.withCredentials)
    loader.load(url, async (text) => {
      try {
        onLoad(await this.parse(text as string))
      }
      catch (e) {
        if (onError) {
          onError(e)
        }
        else {
          console.error(e)
        }

        this.manager.itemError(url)
      }
    }, onProgress, onError)
  }

  async parse(data: string) {
    const targetObject = new THREE.Object3D()

    const occt = await occtimportjs({
      locateFile: () => {
        return 'https://cdn.jsdelivr.net/npm/occt-import-js@0.0.23/dist/occt-import-js.wasm'
      },
    })

    const encoder = new TextEncoder()

    // Encode the string to a Uint8Array
    const uint8Array = encoder.encode(data)
    const result = occt.ReadStepFile(new Uint8Array(uint8Array.buffer), null)

    // process the geometries of the result
    for (const resultMesh of result.meshes) {
      const geometry = new THREE.BufferGeometry()

      geometry.setAttribute('position', new THREE.Float32BufferAttribute(resultMesh.attributes.position.array, 3))
      if (resultMesh.attributes.normal) {
        geometry.setAttribute('normal', new THREE.Float32BufferAttribute(resultMesh.attributes.normal.array, 3))
      }
      // Use 32-bit indices: STEP parts routinely exceed 65535 vertices, which
      // would overflow a Uint16Array and scramble the triangles.
      const index = Uint32Array.from(resultMesh.index.array)
      geometry.setIndex(new THREE.BufferAttribute(index, 1))

      let material: THREE.MeshPhongMaterial
      if (resultMesh.color) {
        const color = new THREE.Color(resultMesh.color[0], resultMesh.color[1], resultMesh.color[2])
        material = new THREE.MeshPhongMaterial({ color: color })
      }
      else {
        material = new THREE.MeshPhongMaterial({ color: 0xcccccc })
      }

      const mesh = new THREE.Mesh(geometry, material)
      targetObject.add(mesh)
    }
    return targetObject
  }
}

export default STEPLoader
